import { render } from "./LeaveStatus.vue?vue&type=template&id=30a33f84&scoped=true"
import script from "./LeaveStatus.vue?vue&type=script&lang=js"
export * from "./LeaveStatus.vue?vue&type=script&lang=js"

import "./LeaveStatus.vue?vue&type=style&index=0&id=30a33f84&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a33f84"]])

export default __exports__